export const loadingPath = "<path d=\"M8 2.5 A5.5 5.5 0 1 0 13.5 8\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>"
